define('app-UKTSDetails/settings',[],function () {
    return {
        container: "#ukTravelContainer",
        getBookUkTravelDetailsUrl: "/bookuktravelservice/index",
        updatePriceUrl: "/bookuktravelservice/updateprice",
        confirmUrl: "/bookuktravelservice/confirm",
        buttonContainer: "#ukTravelBookingButtons",
        getQuoteButton: "#getQuote",
        addToBookingButton: "#addToBooking"
    };
});
